import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M0 3C8 3 16 3.00084 24 3.00084V21.0013H18V13.3982C17.9589 13.358 17.9125 13.3138 17.8608 13.2661C17.593 13.0188 17.1877 12.6829 16.6535 12.3455C15.5862 11.6714 14.0191 11 12 11C9.98093 11 8.41375 11.6714 7.34649 12.3455C6.81232 12.6829 6.40703 13.0188 6.13922 13.2661C6.08754 13.3138 6.04112 13.358 6 13.3982V21.0004H0V3ZM6 10.8364C6.08952 10.776 6.18236 10.7152 6.27851 10.6545C7.58625 9.82857 9.51907 9 12 9C14.4809 9 16.4138 9.82857 17.7215 10.6545C17.8176 10.7152 17.9105 10.776 18 10.8364V5.00057C14 4.99963 10 5 6 5V10.8364Z"}}]};

const Bridge5Filled = Vue.extend<IconProps>({
  name: 'Bridge5FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bridge-5-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bridge5Filled;
